import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from './../config';
import common from './../common';
import { resetErrorMessages, openMobileFilter } from './../actions/FormationActions';
import $ from 'jquery'
import { isEmpty } from 'lodash';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.timeout = null;
    }

    resetPopUp = () => {
        let bodyElem = document.body;

        bodyElem.classList.remove('bodyNoScroll');
        $($.find(".si-main-component")).removeClass("si-high-zindex");
        this.props.resetErrorMessages();
        if (this.props.resetError) {
            this.props.resetError();
        }

    }

    setCommonState(nextProps) {
        const ERROR = nextProps.error;
        const team = ERROR.team;
        const teamID = ERROR.tid;
        let msg1 = null, msg2 = null, icon = null;
        let errorCase = 0;
        const { MaxTeamPlayers } = this.props.constraints;

        if (ERROR.playersPerTeamCountExceeded && ERROR.state === 'level') {
            return
            const seenWarning = common.getLocalStorage('seenWarning');
            if (!seenWarning) {
                msg1 = this.props.trans['you_can_select_up_to'].replace('{COUNT}', MaxTeamPlayers);
                msg2 = this.props.trans['team_constraint_level'].replace('{TEAM_NAME}', ERROR.team);
                common.setLocalStorage('seenWarning', 'true');
                errorCase = 1;
            }
        } else if (ERROR.playersPerTeamCountExceeded && ERROR.state === 'exceed') {
            if (!isEmpty(ERROR)) {
                $($($.find(".si-main-component")[0])).addClass("si-high-zindex");
            }
            msg1 = this.props.trans['team_constraint_exceed'].replace('{CLUBS}');
            errorCase = 2;
        } else if (ERROR.playersPerSkillCountExceeded) {
            if (!isEmpty(ERROR)) {
                $($($.find(".si-main-component")[0])).addClass("si-high-zindex");
            }
            msg1 = this.props.trans['position_constraint'].replace('{POSITION}', this.props.trans[config.positionMap[ERROR.skill].skillTrans]) + " (" + ERROR.maxPlayers + "/" + ERROR.maxPlayers + ")";
            errorCase = 3;
            clearTimeout(this.timeout);
            this.timepout = setTimeout(() => {
                this.resetPopUp();
            }, 3000);
        } else if (nextProps.showOverlay) {
            if (!isEmpty(ERROR)) {
                $($($.find(".si-main-component")[0])).addClass("si-high-zindex");
            }
            errorCase = 4;
        } else if (ERROR.error == 5) {
            if (!isEmpty(ERROR)) {
                $($($.find(".si-main-component")[0])).addClass("si-high-zindex");
            }
            errorCase = 5;
            msg1 = ERROR.msg1;
            icon = ERROR.icon
        }
        this.setState({ errorCase, msg1, msg2, MaxTeamPlayers, team, teamID, icon });
    }

    componentDidMount() {
        // $($('body')).addClass("bodyNoScroll");

        this.setCommonState(this.props);
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    componentDidUpdate() {
        const { errorCase } = this.state;
        if (errorCase === 2) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.closePopup();
            }, 5000);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setCommonState(nextProps);
    }

    closePopup = () => {
        this.setState({});
        this.resetPopUp();
    };

    render() {
        const { errorCase, teamID } = this.state;
        let body = null;
        const { mobileFilterOpen } = this.props;
        const imgSrc = config.UEFAImgBase + `teams/logos/140x140/${teamID}.png`;
        const overlayHandler = mobileFilterOpen ? this.props.openMobileFilter : () => {
        };
        switch (errorCase) {
            case 1: {
                body = <div className="si-modal-wrap" onClick={ () => this.closePopup() }>
                    <div className="si-common-popup si-warning-popup">
                        <div className="si-popup-body si-flexBox">
                            <div className="si-logo-wrap">
                                <div className="si-club-img">
                                    <i className="icon-ucl-generic-badge" />
                                </div>
                                <div className="si-constraint-info"><i className="icon-ucl-info" /></div>
                            </div>
                            <div className="si-details-wrap">
                                <div className="si-title">
                                    { this.props.trans['players_per_club'] }
                                </div>
                                <div className="si-more-info">
                                    <span>{ this.state.msg1 } { this.state.msg2 }</span>
                                </div>
                            </div>
                        </div>
                        <div className="si-popup-btn-wrap">
                            <div className="si-btn si-btn-secondary-wb" onClick={ () => this.closePopup() }>
                                <span>{ this.props.trans.ok }</span>
                            </div>
                        </div>
                    </div>
                </div>;
                break;
            }
            case 2: {
                body = <div className="si-common-toast" onClick={ () => this.closePopup() }>
                    <div className="si-common-popup si-warning-toast">
                        <div className="si-popup-body si-flexBox">
                            <div className="si-logo-wrap">
                                <div className="si-club-img">
                                    <img
                                        src={ imgSrc }
                                        className={ "si-thumbnail" }
                                        alt="" />
                                </div>
                                <div className="si-constraint-info">
                                    <i className="icon-ucl-warning-icon" />
                                </div>
                            </div>
                            <div className="si-details-wrap">
                                <div className="si-more-info">
                                    { this.state.msg1 }
                                    <span className="si-club-name"> { this.state.team } </span>
                                    <span
                                        className="si-plyr-count">{ this.props.trans.pickAnotherTrans ? this.props.trans.pickAnotherTrans : "To pick another, transfer one out" } { " (" + this.state.MaxTeamPlayers }/{ this.state.MaxTeamPlayers + ")" }</span>
                                </div>
                            </div>
                            <i className="si-close icon-ucl-close" onClick={ () => this.closePopup() } />
                        </div>
                    </div>
                </div>;
                break;
            }
            case 3: {
                // body = <div className="si-toast"><span>{this.state.msg1}</span></div>;
                // break;
                body = <div className="si-common-toast" onClick={ () => this.closePopup() }>
                    <div className="si-common-popup si-warning-toast">
                        <div className="si-popup-body si-flexBox">
                            <div className="si-logo-wrap si-skill">
                                <div className="si-club-img">
                                    <span>{ this.props.trans["short" + this.props.error.skill] }</span>
                                </div>
                                <div className="si-constraint-info">
                                    <i className="icon-ucl-warning-icon" />
                                </div>
                            </div>
                            <div className="si-details-wrap">
                                <div className="si-more-info">
                                    { this.state.msg1 }

                                </div>
                            </div>
                            <i className="si-close icon-ucl-close" onClick={ () => this.closePopup() } />
                        </div>
                    </div>
                </div>;
                break;
            }
            case 4: {
                body = <div className="si-overlay" style={ { display: 'block' } } onClick={ () => overlayHandler() } />;
                break;
            }
            case 5: {
                body = <div className="si-common-toast" onClick={ () => this.closePopup() }>
                    <div className="si-common-popup si-warning-toast">
                        <div className="si-popup-body si-flexBox">
                            <div className="si-logo-wrap si-skill si-booster-icons">
                                {/* <div className="si-club-img">
                                    <span>{ this.props.trans["short" + this.props.error.skill] }</span>
                                </div> */}
                                <i className={ this.state.icon } />
                                <div className="si-constraint-info">
                                    <i className="icon-ucl-warning-icon" />
                                </div>
                            </div>
                            <div className="si-details-wrap">
                                <div className="si-more-info">
                                    { this.state.msg1 }

                                </div>
                            </div>
                            <i className="si-close icon-ucl-close" onClick={ () => this.closePopup() } />
                        </div>
                    </div>
                </div>;
                break;
            }
            default: {
                body = null;
            }
        }
        return <div id={ "modal" } >
            { errorCase === 4 ? body : (body && <div className="si-modal-wrap" onClick={ () => { this.closePopup() } }>{ body }</div>) }
        </div >
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        resetErrorMessages: () => dispatch(resetErrorMessages()),
        openMobileFilter: (bool) => dispatch(openMobileFilter(bool)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        mobileFilterOpen: state.formationData.mobileFilterOpen,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Modal);


// WEBPACK FOOTER //
// ./src/components/Modal.js